import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilService } from '../../../shared/util/util.service';
import { ComunicacaoModel } from '../../../shared/models/comunicado.model';
import { TipoComunicadoModel } from '../../../shared/models/tipo-comunicados.model';
import { COMUNICADOS } from '../../../../app.constants';

declare var $: any;


@Injectable()
export class ProcorManutencaoComunicadoService {

  constructor(private httpClient: HttpClient) { }


  getObterTipoComun(): Promise<TipoComunicadoModel[]> {
    return this.httpClient
      .get<TipoComunicadoModel[]>(`${COMUNICADOS}/tipoComun`)
      .toPromise();
  }

  getVerificarComun(tpComunicados: number, sqComunicados: number, anoSq: number): Promise<Boolean> {
    return this.httpClient
      .get<Boolean>(`${COMUNICADOS}/verificarComu/${tpComunicados}/${sqComunicados}/${anoSq}`)
      .toPromise();
  }

  getObterComumicadoByTpComunicado(tpComunicados: number, rows: number, page: number): Promise<ComunicacaoModel[]> {
    return this.httpClient
      .get<ComunicacaoModel[]>(`${COMUNICADOS}/obterComumicadoByTpComunicado/${tpComunicados}?linesPerPage=${rows}&page=${page}`)
      .toPromise();
  }

  getObtermanutcomun(tpComunicados: number, sqComunicados: number, anoSq: number): Promise<ComunicacaoModel> {
    return this.httpClient
      .get<ComunicacaoModel>(`${COMUNICADOS}/obtermanutcomun/${tpComunicados}/${sqComunicados}/${anoSq}`)
      .toPromise();
  }

  insertComunicado(comunicacaoModel: ComunicacaoModel): Promise<any> {
    return this.httpClient
      .post(`${COMUNICADOS}/inserir`, comunicacaoModel)
      .toPromise();
  }

  updateComunicado(comunicacaoModel: ComunicacaoModel): Promise<any> {
    return this.httpClient
      .put(`${COMUNICADOS}/update/${comunicacaoModel.tpComunicados}/${comunicacaoModel.sqComunicados}/${comunicacaoModel.anoSq}`, comunicacaoModel)
      .toPromise();
  }

  deleteComunicado(comunicacaoModel: ComunicacaoModel): Promise<any> {
    return this.httpClient
      .delete(`${COMUNICADOS}/delete/${comunicacaoModel.tpComunicados}/${comunicacaoModel.sqComunicados}/${comunicacaoModel.anoSq}`)
      .toPromise();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/procor-manutencao-comunicado/service/procor-manutencao-comunicado.service.ts